import {
  CountryTaxNewsLinkResponse,
  CountryTaxNewsWithNestedObjectsResponse,
} from 'src/app/web-api-client';
import { TaxNews } from '../models/tax-news';

export const mapTaxNewsFromResponse = (
  {
    countryTaxNewsId,
    countryTaxNewsLinks,
    name,
    description,
    newsDate,
    isActive,
  }: CountryTaxNewsWithNestedObjectsResponse,
  countryId: number
): TaxNews => {
  const selectedCountry = countryTaxNewsLinks?.find(
    (country: CountryTaxNewsLinkResponse) =>
      country.country?.countryId === parseInt(countryId.toString())
  );
  return new TaxNews({
    countryTaxNewsId,
    countryId: selectedCountry?.country?.countryId,
    countryName: selectedCountry?.country?.name,
    name,
    description,
    date: newsDate,
    isActive,
  });
};
